const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://3j1ignxwcf.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://pgu207ckpd.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.pas.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.pas.forwoodsafety.com',
    WEBSOCKET: 'wss://cktts421p0.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;